<template>
  <div style="margin: 16px;">
    <el-card style="height: 100%" body-style="height: 100%; padding-bottom: 60px;">
      <el-table
        :data="objectives"
        :height="windowHeight - 230"
        style="width: 100%; height: 100%;"
        :default-sort="{prop: 'obj_num', order: 'ascending'}"
        @row-dblclick="editObjective"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          :fixed="$mq == 'xs' || $mq == 'sm' ? false : 'left'"
          sortable
          prop="obj_num"
          label="#"
          width="70"
          align="center"
        >
          <template slot-scope="scope">
            <el-input v-if="scope.row.editing" v-model="scope.row.obj_num" size="small" />
            <span v-else>{{ scope.row.obj_num }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="Objective" min-width="500">
          <template slot-scope="scope">
            <el-input v-if="scope.row.editing" v-model="scope.row.title" size="small" />
            <span v-else>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Classes" min-width="200">
          <template slot-scope="scope">
            <el-tag
              v-for="level in scope.row.level"
              :key="scope.row.o_id + level.o_id"
              :closable="scope.row.editing"
              size="mini"
              :disable-transitions="false"
              @close="scope.row.level.splice(scope.row.level.indexOf(level), 1)"
            >{{ level.name }}</el-tag>
            <el-dropdown v-if="scope.row.editing">
              <span class="el-dropdown-link">
                Add
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="level in availableLevels(scope.row.level)"
                  :key="level.o_id"
                  @click.native="scope.row.level.push(level)"
                >{{ level.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column
          :fixed="$mq == 'xs' || $mq == 'sm' ? false : 'right'"
          align="center"
          label="Operations"
          width="120"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                v-if="scope.row.editing"
                type="primary"
                size="small"
                icon="el-icon-check"
                @click="saveObjective(scope.row)"
              />
              <el-button
                v-if="scope.row.editing"
                type="info"
                size="small"
                icon="el-icon-close"
                @click="cancelEditObjective(scope.row)"
              />
              <el-button
                v-if="!scope.row.editing"
                type="primary"
                size="small"
                icon="el-icon-edit"
                @click="editObjective(scope.row)"
              />
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-button-group class="button">
          <el-popover
            v-if="selectedObjects.length != 0"
            v-model="delVisible"
            placement="top"
            width="160"
          >
            <p>Are you sure?</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delVisible=false">Cancel</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="selectedObjects.forEach((event) => {deleteObjective(event);})"
              >Delete</el-button>
            </div>
            <el-button slot="reference" icon="el-icon-delete" type="danger" size="small"></el-button>
          </el-popover>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addObjective" />
          <!--<el-button @click="downloadEvents"type="info" size="small" icon="el-icon-download"></el-button>-->
        </el-button-group>
      </div>
    </el-card>
  </div>
</template>

<style scoped>
.el-tag + .el-tag {
  margin-left: 4px;
}
.button-new-tag {
  height: 24px;
  line-height: 20px;
  padding-top: 0;
  padding-bottom: 0;
}
.el-dropdown-link {
  margin-left: 4px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 10px;
}
.button {
  margin: 4px;
  margin-right: 8px;
  margin-bottom: 0px;
  padding: 8px;
  padding-bottom: 0px;
  float: right;
}
.bottom {
  line-height: 12px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    data() {
        return {
            delVisible: false,
            backupData: [],
            selectedObjects: []
        };
    },
    computed: {...mapFields(["user", "objectives", "levels"])},
    created() {
        if (!this.$store.getters.hasPermission(["All", "Records", "Web"]))
            this.$router.push("/admin");
    },
    mounted() {
        if (this.objectives == null) this.$store.dispatch("pullObjectives");
        if (this.levels == null) this.$store.dispatch("pullLevels");
    },
    methods: {
        handleSelectionChange(val) {
            this.$set(this, "selectedObjects", val);
        },
        // Gets available aslevels for the objective
        availableLevels(levels) {
            return this.levels.filter((level) => {
                return (
                    levels.filter((id) => {
                        return id.o_id == level.o_id;
                    }).length == 0
                );
            });
        },
        handleClick() {
            this.$message({
                showClose: true,
                message: "Move Successfull",
                type: "success"
            });
        },
        editObjective(val) {
            this.backupData[val.o_id] = JSON.parse(JSON.stringify(val));
            val.editing = true;
        },
        addObjective() {
            var top = 0;
            this.objectives.forEach((objv) => {
                if (objv.obj_num > top) {
                    top = objv.obj_num;
                }
            });
            var nob = {
                obj_num: top + 1,
                level: [],
                title: "",
                editing: true,
                delVisible: false,
                o_id: -1
            };
            this.objectives.push(nob);
        },
        cancelEditObjective(row) {
            if (row.o_id == -1) {
                var temp = this.objectives.find((objv) => objv.o_id == -1);
                var index = this.objectives.indexOf(temp);
                this.objectives.splice(index, 1);
            } else {
                row.editing = false;
                this.restoreObjective(row.o_id);
            }
        },
        restoreObjective(id) {
            var temp = this.objectives.find((objv) => objv.o_id == id);
            var orig = this.backupData[id];
            Reflect.deleteProperty(this.backupData, "id");

            temp.obj_num = orig.obj_num;
            temp.title = orig.title;
            temp.level = orig.level;
        },
        saveObjective(row) {
            row.editing = false;
            var levels = [];
            row.level.forEach((level) => {
                levels.push(level.o_id);
            });
            var route = "";
            if (row.o_id != -1) {
                route = "/api/v1/objectives/" + row.o_id;
                this.axios
                    .put(
                        route,
                        JSON.stringify({
                            obj_num: row.obj_num,
                            title: row.title,
                            levels: levels
                        }),
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then(() => {
                        this.$message({
                            showClose: true,
                            message: "Objective saved successfuly.",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                        this.restoreObjective(row.o_id);
                    });
            } else {
                route = "/api/v1/objectives";
                this.axios
                    .post(
                        route,
                        JSON.stringify({
                            obj_num: row.obj_num,
                            title: row.title,
                            levels: levels
                        }),
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then(() => {
                        this.$message({
                            showClose: true,
                            message: "Objective created successfuly",
                            type: "success"
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                        var temp = this.objectives.find((objv) => objv.o_id == -1);
                        var index = this.objectives.indexOf(temp);
                        this.objectives.splice(index, 1);
                    });
            }
        },
        deleteObjective(row) {
            row.delVisible = false;
            this.axios
                .delete("/api/v1/objectives/" + row.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: "Objective deleted successfuly",
                        type: "success"
                    });
                    var temp = this.objectives.find((objv) => objv.o_id == row.o_id);
                    var index = this.objectives.indexOf(temp);
                    this.objectives.splice(index, 1);
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        }
    }
};
</script>
